import React from "react";
import classes from "./DenMap.module.css";

const Footer = props => {
    return <div className={classes.footer}>Thanks to <a href="https://twitter.com/larvesta10/">めらるば (Larvesta10)</a> for providing the graphics.</div>
}

export default Footer;